// extracted by mini-css-extract-plugin
export var compactFilters = "_fk-4";
export var detailImage = "_fk-1";
export var dropdownContainer = "_fk-2";
export var imageContainer = "_fk-0";
export var selectedCard = "_fk-3";